<template>
  <div class="content-container">
    <search-section ref="searchSection" @search="onSearch" />

    <div class="grid-scroll mt-10">
      <GridVx
        ref="agGrid"
        :columns="columns"
        :rows="rows"
        :row-multi-select-with-click="true"
        class="agGrid"
        @refresh="onRefresh"
        @rowClicked="onRowClick"
        @selectionChanged="onSelectRow"
      />
    </div>
    <div class="grid-bottom">
      <GridPaging
        target="agGrid"
        :total-size="pageParams.totalPage"
        :page-num="pageParams.pageNum"
        @pageChanged="onPageChanged"
        @onPageSizeChange="onPageSizeChange"
      />
    </div>
    <div class="button-containers mb-0">
      <button
        class="btn primary small"
        @click="
          isEdit = false
          dialogFormVisible = true
        "
      >
        {{ $t('config.profile.common.add') }}
      </button>
      <button
        class="btn primary small"
        :disabled="selectedRow.length !== 1"
        @click="
          isEdit = true
          dialogFormVisible = true
        "
      >
        {{ $t('config.profile.common.edit') }}
      </button>
      <!-- <button
        class="btn primary small"
        :disabled="selectedRow.length < 2"
        @click="mergeTableDialog"
      >
        {{ $t('config.profile.common.merge') }}
      </button> -->
      <button class="btn primary small" @click="fnGetListAgentToExcelApi">
        {{ $t('config.profile.common.exportExcel') }}
      </button>
      <!-- <button class="btn primary small" @click="importExcelVisible = true">
        {{ $t('config.profile.common.importExcel') }}
      </button> -->
      <button
        class="btn primary small outline"
        :disabled="selectedRow.length < 1"
        @click="fnDeleteAgent"
      >
        {{ $t('config.profile.common.delete') }}
      </button>
    </div>

    <form-dialog
      v-model="dialogFormVisible"
      :profile-id="selectedRow.length === 1 ? selectedRow[0]?.id : null"
      :is-edit="isEdit"
      @resetSearch="onResetSearch"
    />

    <merge-dialog
      v-model="mergeTableVisible"
      :selected-list="selectedRow"
      @resetSearch="onResetSearch"
    />

    <import-excel-dialog v-model="importExcelVisible" />
  </div>
</template>

<script>
import SearchSection from './components/SearchSection.vue'
import FormDialog from './components/FormDialog.vue'
import MergeDialog from './components/MergeDialog.vue'
import ImportExcelDialog from './components/ImportExcelDialog.vue'

import paginationMixin from '@/mixins/paginationMixin'

import {
  getListAgentApi,
  getListAgentToExcelApi,
  deleteAgentApi,
  getMergeProfileApi
} from '@/api/configuration/profile/agent.js'

export default {
  components: {
    SearchSection,
    FormDialog,
    MergeDialog,
    ImportExcelDialog
  },
  mixins: [paginationMixin],
  data() {
    return {
      selectedRow: [],
      rows: [],

      dialogFormVisible: false,
      mergeTableVisible: false,
      importExcelVisible: false,

      searchParams: {
        customerInfo: null,
        sourceId: null, // number
        salesPerson: null // id - number
      },

      // not used yet

      isEdit: false
    }
  },

  computed: {
    columns() {
      return [
        {
          headerName: '',
          field: '',
          minWidth: 50,
          maxWidth: 60,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          checkboxSelection: true,
          resizable: false
        },
        {
          headerName: this.$t('config.profile.field.profileCode'),
          field: 'profile_code',
          wrapText: true,
          autoHeight: true
        },
        {
          headerName: this.$t('config.profile.field.name'),
          field: 'name',
          minWidth: 400,
          wrapText: true,
          autoHeight: true
        },
        {
          headerName: this.$t('config.profile.field.invoiceAgentName'),
          field: 'invoice_agent_name',
          wrapText: true,
          autoHeight: true
        },

        {
          headerName: this.$t('config.profile.field.email'),
          field: 'email'
        },
        {
          headerName: this.$t('config.profile.field.phone'),
          field: 'phone_1'
        },
        // {
        //   headerName: this.$t('config.profile.field.phone2'),
        //   field: 'phone_2'
        // },
        {
          headerName: this.$t('config.profile.field.address'),
          field: 'address_1'
        },
        // {
        //   headerName: this.$t('config.profile.field.address2'),
        //   field: 'address_2'
        // },
        {
          headerName: this.$t('config.profile.field.bankName'),
          field: 'bank_name'
        },
        {
          headerName: this.$t('config.profile.field.bankNumber'),
          field: 'bank_number'
        },
        {
          headerName: this.$t('config.profile.field.businessManName'),
          field: 'business_man_name',
          minWidth: 270,
          flex: 1
        }
      ]
    }
  },

  watch: {
    dialogFormVisible(nv, ov) {
      // if dialog is close
      if (!nv) {
        this.isEdit = false
      }
    }
  },

  beforeMount() {
    this.context = { componentParent: this }
  },
  mounted() {
    this.fnGetListAgent()
  },

  methods: {
    // handle event
    // grid
    onRowClick(index) {},
    onDoubleClicked(rows) {
      // similar with click sua ho so
    },
    onSelectRow(value) {
      this.selectedRow = value
    },

    // search
    onResetSearch() {
      this.searchParams = {
        customerInfo: null,
        sourceId: null, // number
        salesPerson: null // id - number
      }
      this.pageParams = {
        pageNum: 1,
        pageSize: 10,
        totalPage: null,
        orderBy: null,
        orderTp: null // 'asc' or 'desc'
      }
      this.fnGetListAgent()
    },

    // pagination
    async onPageChanged(pageNum) {
      this.pageParams.pageNum = pageNum
      await this.fnGetListAgent()
    },
    async onPageSizeChange(pageSize) {
      this.pageParams.pageSize = pageSize
      this.pageParams.pageNum = 1
      await this.fnGetListAgent()
    },

    mergeTableDialog() {
      if (this.selectedRow.length > 5) {
        this.$message({
          type: 'error',
          message: this.$t(`errorMsg.exceed5ProfileToMerge`)
        })
        return
      }
      this.fnGetMergeProfile(this.selectedRow.map(row => row.id))
    },

    onSearch(searchParams) {
      this.searchParams = { ...searchParams }
      this.pageParams.pageNum = 1
      this.fnGetListAgent()
    },

    // handle call api
    fnGetListAgent() {
      const query = {
        pageSize: this.pageParams.pageSize,
        pageNum: this.pageParams.pageNum,
        orderBy: this.pageParams.orderBy,
        orderTp: this.pageParams.orderTp,
        ...this.searchParams
      }
      getListAgentApi(query)
        .then(data => {
          if (!data.is_error) {
            this.rows = data.data
            this.pageParams.totalPage = Math.ceil(data.total / data.page_size)
            this.pageParams.pageNum = data.page_num
          } else {
            throw new Error(data)
          }
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
        .finally(() => {})
    },
    // Excel API
    fnGetListAgentToExcelApi() {
      this.searchParams = this.$refs.searchSection.searchParams
      const query = {
        orderBy: this.pageParams.orderBy,
        orderTp: this.pageParams.orderTp,
        ...this.searchParams
      }
      getListAgentToExcelApi(query)
        .then(res => {
          if (!res.is_error) {
            const href = URL.createObjectURL(res)
            // create "a" HTML element with href to file & click
            const link = document.createElement('a')
            link.href = href
            link.setAttribute(
              'download',
              'agent-profile.xlsx'
              // res.headers['content-disposition'].split('filename=')[1],
            ) // or any other extension
            document.body.appendChild(link)
            link.click()
            // clean up "a" element & remove ObjectURL
            document.body.removeChild(link)
            URL.revokeObjectURL(href)
          } else {
            throw new Error(res)
          }
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
        .finally(() => {})
    },
    // delete api
    fnDeleteAgent() {
      if (this.selectedRow.length <= 0) {
        this.$alert(this.$t('config.profile.vxConfirm.alert'), 'Error', {
          confirmButtonText: this.$t('config.profile.common.confirmBtnText')
        })
        return
      }
      this.$vxConfirm(this.$t('config.profile.vxConfirm.delete'), () => {
        deleteAgentApi(this.selectedRow.map(row => row.id))
          .then(data => {
            if (!data.is_error) {
              this.$message({
                type: 'success',
                message: this.$t(`successMsg.${data.message}`)
              })

              this.onResetSearch()
            } else {
              throw new Error(data)
            }
          })
          .catch(error => {
            const message = error.response?.data?.message || 'default'
            this.$message({
              type: 'error',
              message: this.$t(`errorMsg.${message}`)
            })
          })
          .finally(() => {})
      })
    },
    // get merge profiles
    fnGetMergeProfile(profileIds) {
      getMergeProfileApi(profileIds)
        .then(data => {
          if (!data.is_error) {
            this.selectedRow = [...data.data]
            this.mergeTableVisible = true
          } else {
            throw new Error(data)
          }
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
        .finally(() => {})
    },

    onRefresh(data) {
      const params = {
        order_by: data.orderBy,
        order_tp: data.sort
      }
      this.searchParams = { ...this.searchParams, ...params }
      this.pageParams.pageNum = 1
      this.fnGetListAgent()
    }
  }
}
</script>
